import React, { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { useT } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "@/components/ui/command";
import { cn } from "@/lib/utils";

// Fix K (2026-09-28): buscador de edificios compartido por «Nueva orden» e Intake. Busca por
// nombre y por dirección: quien recibe el pedido muchas veces tiene la calle y no el nombre.
export const PropertyPicker = ({
  properties, value, onChange, disabled = false, testId = "property-picker", small = false,
  cargando = false,   // Fix P (2026-09-29): mientras llega la lista no dice «ningún edificio coincide»
}) => {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const seleccionado = (properties || []).find((p) => p.id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          disabled={disabled}
          data-testid={testId}
          className={cn(
            "mt-1 w-full justify-between rounded-[6px] font-normal",
            small ? "h-8 text-[12.5px]" : "h-9 text-[13px]"
          )}
        >
          <span className={cn("truncate", !seleccionado && "text-ink-tertiary")}>
            {seleccionado?.nombre || t("wo.form.property_ph")}
          </span>
          <ChevronsUpDown className="ml-2 h-3.5 w-3.5 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[var(--radix-popover-trigger-width)] min-w-[280px] p-0" align="start">
        <Command>
          <CommandInput placeholder={t("wo.form.property_search")} className="text-[13px]" />
          <CommandList>
            <CommandEmpty className="py-4 text-center text-[12.5px] text-ink-tertiary">
              {cargando ? t("wo.form.property_loading") : t("wo.form.property_empty")}
            </CommandEmpty>
            <CommandGroup>
              {(properties || []).map((p) => {
                const calle = [p.direccion?.calle, p.direccion?.ciudad].filter(Boolean).join(", ");
                return (
                  <CommandItem
                    key={p.id}
                    value={`${p.nombre} ${calle}`}
                    onSelect={() => { onChange(p.id); setOpen(false); }}
                    className="text-[13px]"
                  >
                    <Check className={cn("mr-2 h-3.5 w-3.5 shrink-0",
                      value === p.id ? "opacity-100" : "opacity-0")} />
                    <span className="min-w-0">
                      <span className="block truncate">{p.nombre}</span>
                      {!!calle && (
                        <span className="block truncate text-[11.5px] text-ink-tertiary">{calle}</span>
                      )}
                    </span>
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
